import { fetchInfo, createOrder } from "@/api/modules/products/retireetickets";
import moment from "moment";

const InfoModel = function(info) {
    this.identifier = info.productTypeIdentifier;
    this.productVariants = info.productVariants;
};

export const state = {
    info: null,
    municipalityId: null,
    productVariantId: null,
    validFrom: null,
    validTo: null
};

export const mutations = {
    updateInfo: (state, payload) => {
        state.info = new InfoModel(payload.info);
    },
    updateProductVariant: (state, { municipalityId, productVariantId }) => {
        state.municipalityId = municipalityId;
        state.productVariantId = productVariantId;
        state.validFrom = null;
        state.validTo = null;
    },
    updateValidFrom: (state, from) => {
        state.validFrom = moment(from)
            .tz("Europe/Copenhagen")
            .startOf("day")
            .toDate();
    },
    updateValidTo: (state, to) => {
        state.validTo = moment(to)
            .tz("Europe/Copenhagen")
            .startOf("day")
            .toDate();
    }
};

export const getters = {
    getMunicipalities: state => {
        if (!state.info || !state.info.productVariants) return [];
        const unique = [];
        state.info.productVariants.forEach(p => {
            if (p.municipality) {
                if (!unique.filter(m => m.id === p.municipality.id).length) {
                    unique.push({ ...p.municipality });
                }
            }
        });
        return unique;
    },
    getAvailableProductVariants: state => {
        if (!state.info || !state.info.productVariants) return [];
        return state.info.productVariants.filter(
            p => p.municipality.id === state.municipalityId
        );
    },
    getSelectedProductVariant: (state, getters) => {
        if (!state.info || !state.info.productVariants) return null;
        return (
            getters.getAvailableProductVariants.find(
                p => p.id === state.productVariantId
            ) || getters.getAvailableProductVariants[0]
        );
    },
    getValidFrom: state => state.validFrom,
    getValidTo: state => state.validTo,
    getAmountOfDays: ({ validFrom, validTo }) => {
        if (!validFrom || !validTo) return null;
        return moment(validTo).diff(validFrom, "days") + 1;
    },
    getTotalPriceOre: (
        state,
        { getSelectedProductVariant, getAmountOfDays }
    ) => {
        if (!getSelectedProductVariant || !getAmountOfDays) return null;
        return getSelectedProductVariant.dayPriceInOre * getAmountOfDays;
    },
    getTotalPriceOreWithDelivery: (state, getters, rootState, rootGetters  ) => {
        let deliveryPrice = rootGetters["system/snailmailShipmentFeeInOre"];
        let ticketPrice = getters.getTotalPriceOre;
        return ticketPrice == null ? null : ticketPrice + deliveryPrice;
    },
    isValid: (state, getters) =>
        Boolean(state.validFrom) &&
        Boolean(state.validTo) &&
        Boolean(getters.getSelectedProductVariant)
};

export const actions = {
    fetchInfo: context => {
        // If we already have the list. we should not call the endpoint again
        if (context.state.info) {
            return Promise.resolve();
        }

        return fetchInfo(true)
            .then(response => {
                if (!response.ok) throw new Error(response.responseBody);
                return response.responseBody;
            })
            .then(response => {
                context.commit("updateInfo", { info: response });
            });
    },
    prepareOrder: (context, { municipalityId, productVariantId }) => {
        if (
            !municipalityId ||
            !context.getters.getMunicipalities.find(
                m => m.id === municipalityId
            )
        )
            throw new Error(
                "cannot prepare retiree ticket order without a valid municipality ID"
            );

        context.commit("updateProductVariant", {
            municipalityId,
            productVariantId
        });

        context.commit("order/setDeliveryMethod", "snailmail", { root: true });

        return Promise.resolve(true);
    },
    createOrder: context => {
        const productVariantId = context.getters.getSelectedProductVariant.id;
        const validFrom = context.getters.getValidFrom;
        const amountOfDays = context.getters.getAmountOfDays;
        const totalPriceOre = context.getters.getTotalPriceOreWithDelivery;

        return createOrder(productVariantId, validFrom, amountOfDays)
            .then(response => {
                if (!response.ok) throw new Error(JSON.stringify(response));
                return response.responseBody;
            })
            // eslint-disable-next-line no-unused-vars
            .then(({ orderId, _priceOre, ...details }) => {
                context.commit("order/setOrderId", orderId, { root: true });
                context.commit("order/setPriceOre", totalPriceOre, { root: true });
                context.commit(
                    "order/setDetails",
                    {
                        ...details
                    },
                    { root: true }
                );
            });
    },
};
